export default function Watermark() {
  return {}
}
